import { z } from 'zod';

export const GO_ORIGIN = 'GO' as const;

export const OriginSchema = z.string().default(GO_ORIGIN);